import { useSearchParams } from 'react-router-dom';
import { isInboxShow } from './inboxFilters';
import type { InboxShow } from './InboxShow';

/**
 * Фільтри «Моїх вхідних» в адресі: ?show= (усі, непрочитані або вид) і ?space= (робочий простір; порожньо — усі). Спільні для лівого меню
 * вхідних і сторінки; посилання «Непрочитані у вхідних» Головної відкриває show=unread&space=<простір>.
 */
export function useInboxParams(): { show: InboxShow; space: string; setShow: (show: InboxShow) => void; setSpace: (space: string) => void } {
  const [params, setParams] = useSearchParams();
  const raw = params.get('show');
  const show: InboxShow = isInboxShow(raw) ? raw : 'all';
  const space = params.get('space') ?? '';
  const write = (next: Record<string, string>) => {
    const out = new URLSearchParams();
    Object.entries({ show, space, ...next }).forEach(([k, v]) => { if (v && !(k === 'show' && v === 'all')) out.set(k, v); });
    setParams(out, { replace: true });
  };
  return { show, space, setShow: (s) => write({ show: s }), setSpace: (s) => write({ space: s }) };
}
